import React, { Fragment, useState } from "react";
import {
  Dialog, DialogActions, DialogContent,
  DialogContentText, Box, Link, Typography,
  Button,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import sendRequest from '../utils/sendRequest';
import { MenuButtonIcon, DangerButton, CancelButton, WarningButton } from "../styled/CustomButtons";
import { CustomDialogTitle } from "../styled/DialogTitles";

export default function DeletePoDialog({
  isApproved, buttonLoading, setButtonLoading = null,
  po_doc_id, poName, addSnackbar, fetchPos = null, fetchPoDetails = null, scPoId,
  isIcon,
}) {
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [archiveOpen, setArchiveOpen] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [loadingArchive, setLoadingArchive] = useState(false);

  const fetchAction = fetchPos ? fetchPos : fetchPoDetails;

  const handleOpenDelete = () => {
    setDeleteOpen(true);
  };

  const handleCloseDelete = () => {
    if (!loadingDelete) {
      setDeleteOpen(false);
    }
  };

  const handleOpenArchive = () => {
    setDeleteOpen(false);
    setArchiveOpen(true);
  };

  const handleCloseArchive = () => {
    if (!loadingArchive) {
      setArchiveOpen(false);
    }
  };

  const deletePurchaseOrder = async () => {
    if (setButtonLoading) setButtonLoading(true);
    setLoadingDelete(true);
    try {
      let approved = isApproved ? "approved" : "unapproved";
      let response = await sendRequest(`purchase-orders/${approved}?po_doc_id=${po_doc_id}`, null, 'DELETE');
      fetchAction();
      addSnackbar(response.message);
    } catch (error) {
      addSnackbar(error.message, false);
    } finally {
      handleCloseDelete();
      if (setButtonLoading) setButtonLoading(false);
      setLoadingDelete(false);
    }
  }

  const archivePurchaseOrder = async () => {
    if (setButtonLoading) setButtonLoading(true);
    setLoadingArchive(true);
    try {
      let response = await sendRequest(`purchase-orders/archive-po?po_doc_id=${po_doc_id}`);
      fetchAction();
      addSnackbar(response.message);
    } catch (error) {
      addSnackbar(error.message, false);
    } finally {
      handleCloseArchive();
      if (setButtonLoading) setButtonLoading(false);
      setLoadingArchive(false);
    }
  }

  function SellercloudLink({ message, scId }) {
    return (
      <Typography mt={2}>
        <strong>{message}</strong>
        <Link
          href={`https://lux.delta.sellercloud.com/purchasing/po-details.aspx?id=${scId}`}
          target="_blank"
          rel="noopener noreferrer"
          underline="hover"
        >
          {scId}
        </Link>
      </Typography>
    );
  }

  return (
    <Fragment>
      {isIcon ? (
        <MenuButtonIcon
          isIcon={true}
          title={"Delete/Archive PO"}
          icon={DeleteIcon}
          variant="text"
          iconProps={{ color: "error" }}
          onClick={handleOpenDelete}
          disabled={buttonLoading}
        />
      ) : (
        <Box>
          <Button
            variant="text"
            onClick={handleOpenDelete}
            sx={{ color: 'error.main' }}
          >
            Delete/Archive PO
          </Button>
        </Box>
      )}
      <Dialog
        open={deleteOpen}
        onClose={handleCloseDelete}
        disableEscapeKeyDown={loadingDelete}
      >
        <CustomDialogTitle
          header={"Delete/Archive PO"}
          poName={poName}
        />
        <DialogContent>
          <DialogContentText>
            <Typography>
              Are you sure you want to delete this PO? This action is irreversible!
            </Typography>
            {
              scPoId && <SellercloudLink
                message={'Delete or close the PO in Sellercloud if neccessary: '}
                scId={scPoId}
              />
            }
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ display: 'flex', justifyContent: 'space-between', px: 3, pb: 2 }} >
          <CancelButton onClick={handleCloseDelete} disabled={loadingDelete}>Cancel</CancelButton>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <WarningButton
              showSpinner={false}
              text={"Archive"}
              onClick={handleOpenArchive}
              disabled={loadingDelete}
            />
            <DangerButton
              showSpinner={loadingDelete}
              text={"Delete"}
              onClick={() =>deletePurchaseOrder()}
              disabled={loadingDelete}
            />
          </Box>
        </DialogActions>
      </Dialog>
      <Dialog
        open={archiveOpen}
        onClose={handleCloseArchive}
        disableEscapeKeyDown={loadingArchive}
      >
        <CustomDialogTitle
          header={"Archive PO"}
          poName={poName}
        />
        <DialogContent>
          <DialogContentText>
            Are you sure you want to archive this PO?
            {
              scPoId && <SellercloudLink
                message={'Close or delete the PO in Sellercloud if neccessary: '}
                scId={scPoId}
              />
            }
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <CancelButton onClick={handleCloseArchive} disabled={loadingArchive}>Cancel</CancelButton>
          <WarningButton
            showSpinner={loadingArchive}
            text={"Archive"}
            onClick={() =>archivePurchaseOrder()}
            disabled={loadingArchive}
          />
        </DialogActions>
      </Dialog>
    </Fragment>
  )
}